<i18n src="@/locales/models/container_final_quality.yml" lang="yaml"></i18n>
<template>
  <RadioGroup v-model="selected_value" class="mt-2">
    <div class="grid grid-cols-3 gap-3">
      <RadioGroupOption
        as="template"
        v-for="container_final_quality_status in container_final_quality_statuses"
        :key="container_final_quality_status.id"
        :value="container_final_quality_status.id"
        v-slot="{ active, checked }"
      >
        <div
          :class="[
            'cursor-pointer focus:outline-none',
            guiActive(active, container_final_quality_status),
            guiChecked(checked, container_final_quality_status),
            'border rounded-md py-1 px-1 flex items-center justify-center text-sm font-medium sm:flex-1'
          ]"
        >
          <RadioGroupLabel as="span">
            {{
              $t(
                `model.container_final_quality.statuses.${container_final_quality_status.key}`
              )
            }}
          </RadioGroupLabel>
        </div>
      </RadioGroupOption>
    </div>
  </RadioGroup>
</template>

<script>
import { RadioGroup, RadioGroupLabel, RadioGroupOption } from "@headlessui/vue";
import ContainerFinalQualityMixin from "@/components/views/mixins/models/container_final_quality.js";

export default {
  ame: "AEProductionBasicContainerQualityContainerFinalQualityStatusSelector",
  components: { RadioGroup, RadioGroupLabel, RadioGroupOption },
  mixins: [ContainerFinalQualityMixin],
  props: ["modelValue"],
  data() {
    return {
      selected_value: this.modelValue
    };
  },
  updated() {
    this.selected_value = this.modelValue;
  },
  computed: {
    container_final_quality_statuses() {
      return this.containerFinalQualityStatuses;
    }
  },
  methods: {
    guiActive(active, container_final_quality_status) {
      return active
        ? `ring-2 ring-offset-2 ring-${container_final_quality_status.color}-500`
        : "";
    },
    guiChecked(checked, container_final_quality_status) {
      let color = container_final_quality_status.color;
      return checked
        ? `bg-${color}-100 border-transparent text-${color}-800 hover:bg-${color}-100 focus:ring-${color}-500 focus:border-${color}-500`
        : "bg-white border-gray-200 text-gray-900 hover:bg-gray-50";
    }
  },
  watch: {
    selected_value: function (newValue) {
      this.$emit("update:modelValue", newValue);
    }
  }
};
</script>
